import { render, staticRenderFns } from "./DiffForm.vue?vue&type=template&id=259b7623&scoped=true"
import script from "./DiffForm.vue?vue&type=script&lang=ts"
export * from "./DiffForm.vue?vue&type=script&lang=ts"
import style0 from "./DiffForm.vue?vue&type=style&index=0&id=259b7623&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259b7623",
  null
  
)

export default component.exports